import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../ff/services/authentication/authentication.service';
import { take, tap } from 'rxjs/operators';
import { timer, Subscription } from 'rxjs';

@Component({
  selector: 'ff-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit, OnDestroy {
  is_waiting_for_mfa = true;
  errors: string[] = [];
  messages: any[] = [];
  current_user: string | null = null;
  // errors = [];
  // messages: any[] = [];
  // current_user;
  action = {
    path: '/application/portal',
    name: 'NAVIGATE HOME',
  }

  sunset_time_epoch_ms = Date.now() + ( 1000 * 60 * 15 )// Sunset is 15 minutes for mfa verification.

  remaining_time = 15 * 60

  private waiting_interval: any;
  private countdown_subscription?: Subscription;

  constructor(
    private router: Router,
    private authentication_service: AuthenticationService,
  ) {
    // Interval to check MFA completion status every 5 seconds
    this.waiting_interval = setInterval(() => {
      this.is_waiting_for_mfa = !this.authentication_service.is_mfa_complete;
    }, 5000);

    // Timeout for MFA expiry
    setTimeout(() => {
      this.errors.push('Failed to complete MFA within time limit of 15 minutes. Please login again to retry.');
      this.action = {
        path: '/application/authentication',
        name: 'LOGIN',
      };
      clearInterval(this.waiting_interval);
      this.is_waiting_for_mfa = false;
    }, 15 * 60 * 1000);

    // Safe retrieval of current user email
    this.current_user = this.authentication_service.current_user.user_contact_email || null;

    // Countdown timer subscription
    this.countdown_subscription = timer(0, 1000).pipe(
      take(this.remaining_time),
      tap(() => {
        if (this.remaining_time > 0) {
          this.remaining_time--;
        }
      }),
    ).subscribe();
/*
    this.waiting_interval = setInterval(() => {
      this.is_waiting_for_mfa = ! this.authentication_service.is_mfa_complete;
    }, 5000);


    // TODO: HARDCODED 5 minute!!
    // Stop waiting after 5 minutes?? Need to get timeout from server.
    setTimeout(() => {
      this.errors.push('Failed to complete MFA within time limit of 15 minutes. Please login again to retry.');
      this.action = {
        path: 'application/authentication',
        name: 'LOGIN',
      };
      clearInterval(waiting_interval);
      this.is_waiting_for_mfa = false;
    }, 15 * 60 * 1000)

    this.current_user = authentication_service.current_user.user_contact_email

     timer(15 * 60, 1000).pipe(
       take(this.remaining_time),
       map(() => {
         if (this.remaining_time > 0) {
          --this.remaining_time;
         }
       }),
     ).subscribe();
  */
  }

  do_action() {
    this.router.navigate([this.action.path]);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.waiting_interval) {
      clearInterval(this.waiting_interval);
    }
    this.countdown_subscription.unsubscribe();
  }

  // format_time(milliseconds) {
  //   const seconds = Math.round(milliseconds / 1000);
  //   const s = Math.round(seconds % 60);
  //   const m = Math.round((seconds / 60) % 60);
  //   const h = (seconds / (60 * 60)) % 24;
  //   return `${m}:${s}`;
  // }

}
